import React, { FC } from 'react';

import { useCompaniesWithFilterQuery } from 'Dictionary/query/dictionaryQuery';
import { mapToAutocompleteFieldItems } from 'Dictionary/model/Company';
import {
  FormikAutocompleteField,
  FormikAutocompleteFieldProps,
} from 'components/FormikField/FormikAutocompleteField/FormikAutocompleteField';
import { CompanyFilterParams } from 'Dictionary/model/CompanyFilterParams';

export interface CompanyByCountrySelectFieldProps
  extends Omit<FormikAutocompleteFieldProps, 'options'> {
  //filterParams: CompanyFilterParams;
  countryIds: number[];
}

// export const mapCompanyFilterParams = (
//   businessUnit: AutocompleteFieldItem,
//   countryList: AutocompleteFieldItem[]
// ): CompanyFilterParams => ({
//   businessUnitID: Number(businessUnit.id),
//   countryIds: countryList.map((country) => Number(country.id)),
// });

export const CompanyByCountrySelectField: FC<CompanyByCountrySelectFieldProps> = ({
  countryIds,
  multiple = true,
  disabled = false,
  ...otherProps
}) => {
  const { data = [], isLoading, refetch } = useCompaniesWithFilterQuery( 
    {countryIds} as CompanyFilterParams
  );

  return (
    <FormikAutocompleteField
      {...otherProps}
      disabled={disabled}
      options={mapToAutocompleteFieldItems(data)}
      loading={isLoading}
      onOpen={() => refetch()}
      multiple={multiple}
    />
  );
};
